import { inject, Injectable, Injector } from '@angular/core';
import { ComponentProps, createElement, ElementType, PropsWithChildren, createContext } from 'react';
import { Root } from 'react-dom/client';

export const InjectorCtx = createContext<Injector>(null);

function NgContext(props: PropsWithChildren<{ injector: Injector }>) {
  return createElement(InjectorCtx.Provider, {
    children: props.children,
    value: props.injector
  });
}

@Injectable({ providedIn: 'root' })
export class InjectorContextProviderService {
  private injector: Injector = inject(Injector);

  public render<Comp extends ElementType>(root: Root, comp: Comp, compProps?: ComponentProps<Comp>) {
    const reactNode = createElement(
      NgContext,
      {
        injector: this.injector
      },
      createElement(comp, compProps)
    );

    root.render(reactNode);
  }
}
